import React from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import StatusIcon from "../../Icons/StatusIcon";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import Spinner from "../../Components/Reusable/Spinner";
import useDeleteHook from "../../customHooks/useDeleteHook";
import { useParams } from "react-router-dom";
const SubmittedFormDataComponent = loadable(
  () => import("../../Components/SubmittedFormData")
);
const PinnedFormData = () => {
  const { formId } = useParams();
  const { data: formDetail, isLoading: formDataLoading } = useGetHook({
    queryKey: [`${formId}`],
    url: `${APIS.FORM}${formId}/`,
    params: {},
  });
  const { data: formField, isLoading: formFielLoading } = useGetHook({
    queryKey: [`form-field-${formId}`],
    url: `${APIS.FORM_FIELD}`,
    params: {
      form: formId,
      limit:10,
      offset:0
    },
  });


  const { data, isLoading } = useGetHook({
    queryKey: [`${formId}`],
    url: `${APIS.FORM_DATA}`,
    params: {
      form: formId,
      limit: 10,
      offset: 0,
    },
  });
  const { mutateAsync } = useDeleteHook({
    queryKey: ["form_data"],
    navigateURL: "",
  });
  const handleDelete = async (setIsOpen: any, id: any) => {
    const url = `${APIS.FORM_DATA}${id}/`;
    try {
      const res = await mutateAsync({ url });
      if (res?.status === 204) {
        setIsOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <>
        <div
          className={tw`w-full flex justify-left gap-x-2 uppercase font-extrabold items-center`}
        >
          <StatusIcon />
          <span className={tw`text-[#5E5757] font-bold text-xl`}>
            {formDetail?.title}
          </span>
        </div>
        {isLoading || formDataLoading ? (
          <Spinner />
        ) : (
          <SubmittedFormDataComponent
            fields={formField?.results?.[0]?.form_field??[]}
            formId={formDetail?.id}
            handleDelete={handleDelete}
            isReply={formDetail?.is_reply}
          />
          // <ContactUsListComponent data={data} handleDelete={handleDelete} />
        )}
      </>
    </>
  );
};

export default PinnedFormData;
